import { createRoute, useLoaderData } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { selectionAssistantPageQueryOptions } from "~/app/api/pageData/selectionAssistantPageQuery";
import { unwrapPageInitialData, type PageInitialData } from "~/app/api/pageData";
import { StorefrontShellFrame } from "~/app/shell/StorefrontShellFrame";
import { useStorefrontShellProps } from "~/app/router/storefrontShellPropsContext";
import { createSelectionAssistant } from "~/pages/BearingSelectionAssistantPage/BearingSelectionAssistantPage";
import { rootRoute } from "~/app/router/rootRoute";

function SelectionAssistantRoute() {
  const result = useLoaderData({
    from: "/selectionassistant",
  }) as PageInitialData<void>;
  const shellProps = useStorefrontShellProps();

  return (
    <StorefrontShellFrame variant={shellProps.variant} metadata={result.metadata}>
      {createSelectionAssistant()}
    </StorefrontShellFrame>
  );
}

export async function loadSelectionAssistantPageData(context: { queryClient: QueryClient }) {
  const result = await context.queryClient.ensureQueryData(selectionAssistantPageQueryOptions());

  return unwrapPageInitialData(result);
}

export const selectionAssistantRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/selectionassistant",
  loader: async ({ context }) => loadSelectionAssistantPageData(context),
  component: SelectionAssistantRoute,
});
